


















































import CommonBase from "../CommonBase";
import {Component} from "vue-property-decorator";
import rd from "../../modules/vRoutedefs";

@Component
export default class RoleInfo extends CommonBase {

    get notificationsTo() {
        return {name: rd.start.me.notifications.name};
    }
}
